import { useEffect, useState } from "react";
import { Card, CardBody, CardExpandToggler } from "../card/card";

const MovementsLog = ({ title, data, type }) => {
	console.log(data);
	const [activityLogData, setActivityLogData] = useState([]);

	useEffect(() => {
		setActivityLogData(data);
	}, [data]);

	return (
		<div className="col-xl-6">
			<Card className="mb-3">
				<CardBody>
					<div className="d-flex fw-bold small mb-3">
						<span className="flex-grow-1">{title}</span>
						<CardExpandToggler />
					</div>
					<div className="table-responsive">
						<table className="table table-striped table-borderless mb-2px small text-nowrap">
							<tbody>
								{activityLogData && activityLogData.length > 0 ? (
									activityLogData.map((item, index) =>
										type === "customer" ? (
											<tr key={item.id || index}>
												<td>{item.name}</td>
												<td>{item.phone}</td>
												<td>{new Date(item.lastContact).toLocaleDateString('es-ES')}</td>
											</tr>
										) : type === "appointment" ? (
											<tr key={item.idCita || index}>
												<td>{item.nombreCliente}</td>
												<td>{item.nombreVehiculo}</td>
												<td>{new Date(item.fechaHoraCita).toLocaleDateString('es-ES', { 
													day: '2-digit', 
													month: '2-digit', 
													year: 'numeric',
													hour: '2-digit',
													minute: '2-digit'
												})}</td>
											</tr>
										) : (
											<tr key={item.id || index}>
												<td>{item.userName}</td>
												<td>{item.title}</td>
												<td>{item.amount}</td>
											</tr>
										)
									)
								) : (
									<tr>
										<td colSpan="3">No se encontraron resultados</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
				</CardBody>
			</Card>
		</div>
	);
};

export default MovementsLog;
